
import { ScoutPath } from '../../core/models/scout-task'
import { KmlBuilder, KmlBuilderPath } from '../../shared/mapping/kml/kml-builder';

export class ScoutKmlBuilder extends KmlBuilder {

	static scoutPathAsKmlBuilderPath(args: {
		scoutPath: ScoutPath;
		buildingId: string
	}): KmlBuilderPath {
		const { scoutPath, buildingId } = args;
		return {
			id: scoutPath.id,
			pathNumber: scoutPath.pathNumber ?? 0,
			buildingId,
			floor: scoutPath.floor ?? '',
			points: scoutPath.scoutPoints.map(scoutPoint => {
				return {
					id: scoutPoint.id,
					name: scoutPoint.name,
					pointId: scoutPoint.pointId,
					exPointId: scoutPoint.exPointId,
					parentId: scoutPoint.parentId,
					type: scoutPoint.type,
					latitude: scoutPoint.latitude,
					longitude: scoutPoint.longitude,
					altitudeEllipsoidMeters: scoutPoint.altitudeEllipsoidMeters ?? 0,
					color: scoutPoint.color,
					disabled: scoutPoint.disabled
				};
			})
		};
	}

	constructor(
		buildingId: string,
		scoutPaths : ScoutPath[] | undefined) {
		super();
		this.paths = scoutPaths?.map(scoutPath=>ScoutKmlBuilder.scoutPathAsKmlBuilderPath({scoutPath,buildingId}))||[];
	}
}

